(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["key-notes-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('key-notes-slider')) {
    class KeyNotesSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.frame = 0;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.onScroll, { passive: true });
        }

        this.bindDrag();
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      bindDrag() {
        const track = this.track;
        let startX = 0;
        let startLeft = 0;
        let dragging = false;

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragging = true;
          startX = event.clientX;
          startLeft = track.scrollLeft;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        });

        track.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          track.scrollLeft = startLeft - (event.clientX - startX);
        });

        const stop = () => {
          if (!dragging) return;
          dragging = false;
          track.classList.remove('is-dragging');
        };
        track.addEventListener('pointerup', stop);
        track.addEventListener('pointercancel', stop);
      }

      update() {
        const { scrollWidth, clientWidth } = this.track;
        const left = Math.abs(this.track.scrollLeft);
        const max = scrollWidth - clientWidth;
        const scrollable = max > 4;

        this.toggleAttribute('data-can-prev', scrollable && left > 4);
        this.toggleAttribute('data-can-next', scrollable && left < max - 4);

        if (scrollable) this.track.setAttribute('tabindex', '0');
        else this.track.removeAttribute('tabindex');
      }
    }

    customElements.define('key-notes-slider', KeyNotesSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["longevity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('longevity-meter')) {
    class LongevityMeter extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!('IntersectionObserver' in window) || reduce) return;

        this.setAttribute('data-armed', '');
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.setAttribute('data-in', '');
          this.observer.disconnect();
        }, { threshold: 0.6 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('longevity-meter', LongevityMeter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["note-tiers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('note-tiers-slider')) {
    class NoteTiersSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.frame = 0;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.onScroll, { passive: true });
        }

        this.bindDrag();
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      bindDrag() {
        const track = this.track;
        let startX = 0;
        let startLeft = 0;
        let dragging = false;

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragging = true;
          startX = event.clientX;
          startLeft = track.scrollLeft;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        });

        track.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          track.scrollLeft = startLeft - (event.clientX - startX);
        });

        const stop = () => {
          if (!dragging) return;
          dragging = false;
          track.classList.remove('is-dragging');
        };
        track.addEventListener('pointerup', stop);
        track.addEventListener('pointercancel', stop);
      }

      update() {
        const { scrollWidth, clientWidth } = this.track;
        const left = Math.abs(this.track.scrollLeft);
        const max = scrollWidth - clientWidth;
        const scrollable = max > 4;

        this.toggleAttribute('data-can-prev', scrollable && left > 4);
        this.toggleAttribute('data-can-next', scrollable && left < max - 4);

        if (scrollable) this.track.setAttribute('tabindex', '0');
        else this.track.removeAttribute('tabindex');
      }
    }

    customElements.define('note-tiers-slider', NoteTiersSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-checker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hy-delivery-checker')) {
    class HyDeliveryChecker extends HTMLElement {
      connectedCallback() {
        this.inputState = this.querySelector('[data-input-state]');
        this.resultState = this.querySelector('[data-result-state]');
        this.input = this.querySelector('[data-input]');
        this.checkBtn = this.querySelector('[data-check-btn]');
        this.changeBtn = this.querySelector('[data-change-btn]');
        this.errorEl = this.querySelector('[data-error]');
        this.locationText = this.querySelector('[data-location-text]');
        this.sellingFastRow = this.querySelector('[data-selling-fast-row]');
        this.sellingLocation = this.querySelector('[data-selling-location]');
        this.deliveryText = this.querySelector('[data-delivery-text]');
        this.countdownText = this.querySelector('[data-countdown-text]');

        this.sellingFast = this.dataset.sellingFast === 'true';
        this.keralaDays = parseInt(this.dataset.keralaDays, 10) || 4;
        this.otherDays = parseInt(this.dataset.otherDays, 10) || 7;
        this.cutoffHour = parseInt(this.dataset.cutoffHour, 10);
        this.shipHour = parseInt(this.dataset.shipHour, 10);
        if (Number.isNaN(this.cutoffHour)) this.cutoffHour = 15;
        if (Number.isNaN(this.shipHour)) this.shipHour = 19;

        this.countdownTimer = null;
        this.abortController = null;

        this.storageKey = 'hy_delivery_pincode';

        this.checkBtn.addEventListener('click', () => this.submit());
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') this.submit();
        });
        this.changeBtn.addEventListener('click', () => this.reset());

        this.restore();
      }

      disconnectedCallback() {
        if (this.countdownTimer) clearInterval(this.countdownTimer);
        if (this.abortController) this.abortController.abort();
      }

      pad(n) {
        return String(n).padStart(2, '0');
      }

      formatDate(date) {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return `${days[date.getDay()]}, ${date.getDate()} ${months[date.getMonth()]}`;
      }

      calcDeliveryDate(state) {
        const isKerala = state.trim().toLowerCase() === 'kerala';
        const daysToAdd = isKerala ? this.keralaDays : this.otherDays;
        const date = new Date();
        date.setDate(date.getDate() + daysToAdd);
        return date;
      }

      startCountdown() {
        if (this.countdownTimer) clearInterval(this.countdownTimer);

        const tick = () => {
          const now = new Date();
          const cutoff = new Date();
          cutoff.setHours(this.cutoffHour, 0, 0, 0);

          if (now >= cutoff) {
            this.countdownText.innerHTML =
              '<span class="hy-dc__label" style="display:inline;letter-spacing:normal;text-transform:none;font-weight:400;font-size:inherit;margin:0">Order now &mdash; </span>' +
              '<span class="hy-dc__value">ships tomorrow</span>';
            if (this.countdownTimer) clearInterval(this.countdownTimer);
            return;
          }

          const diff = cutoff - now;
          const hh = Math.floor(diff / 3600000);
          const mm = Math.floor((diff % 3600000) / 60000);
          const ss = Math.floor((diff % 60000) / 1000);

          this.countdownText.innerHTML =
            'Order within ' +
            `<span class="hy-dc__time">${this.pad(hh)}h</span>` +
            '<span class="hy-dc__colon">:</span>' +
            `<span class="hy-dc__time">${this.pad(mm)}m</span>` +
            '<span class="hy-dc__colon">:</span>' +
            `<span class="hy-dc__time">${this.pad(ss)}s</span>` +
            ' &mdash; ships today';
        };

        tick();
        this.countdownTimer = setInterval(tick, 1000);
      }

      showResult(pincode, district, state) {
        this.sellingLocation.textContent = district;

        this.locationText.innerHTML =
          'Delivering to ' +
          `<span class="hy-dc__value">${district} ${pincode}</span>`;

        this.sellingFastRow.hidden = !this.sellingFast;

        const deliveryDate = this.calcDeliveryDate(state);
        this.deliveryText.innerHTML =
          'Expected delivery by ' +
          `<span class="hy-dc__value">${this.formatDate(deliveryDate)}</span>`;

        this.startCountdown();

        this.inputState.hidden = true;
        this.resultState.classList.add('is-active');
      }

      async checkPincode(pincode) {
        this.errorEl.textContent = '';
        this.checkBtn.disabled = true;
        this.checkBtn.textContent = 'Checking...';

        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        try {
          const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`, {
            signal: this.abortController.signal
          });
          const data = await res.json();

          if (!data || !data[0] || data[0].Status !== 'Success') {
            this.errorEl.textContent = 'Invalid pincode';
            return;
          }

          const po = data[0].PostOffice[0];
          const district = po.District || '';
          const state = po.State || '';

          try {
            localStorage.setItem(this.storageKey, JSON.stringify({ pincode, district, state }));
          } catch (e) {
            // Storage unavailable (private mode) — non-fatal
          }

          this.showResult(pincode, district, state);
        } catch (err) {
          if (err.name !== 'AbortError') {
            this.errorEl.textContent = 'Could not check that pincode. Please try again.';
          }
        } finally {
          this.checkBtn.disabled = false;
          this.checkBtn.textContent = 'Check';
        }
      }

      submit() {
        const value = this.input.value.trim();

        if (!/^\d{6}$/.test(value)) {
          this.errorEl.textContent = 'Please enter a valid 6-digit pincode.';
          return;
        }

        this.checkPincode(value);
      }

      reset() {
        try {
          localStorage.removeItem(this.storageKey);
        } catch (e) {
          // Storage unavailable — non-fatal
        }

        if (this.countdownTimer) clearInterval(this.countdownTimer);

        this.resultState.classList.remove('is-active');
        this.inputState.hidden = false;
        this.input.value = '';
        this.input.focus();
      }

      restore() {
        let saved = null;
        try {
          saved = JSON.parse(localStorage.getItem(this.storageKey) || 'null');
        } catch (e) {
          saved = null;
        }

        if (saved && saved.pincode && saved.district && saved.state) {
          this.showResult(saved.pincode, saved.district, saved.state);
        }
      }
    }

    customElements.define('hy-delivery-checker', HyDeliveryChecker);
  }
  } catch(e) { console.error(e); }
})();

})();
